import { B as y } from "./chunk-BaseElement-BuXbltG-.js";
import { W as g } from "./chunk-WithModalDialog-D_8a5ywe.js";
import { x as l, E as w, r as k } from "./chunk-lit-element-CNHURX5C.js";
import { t as v } from "./chunk-custom-element-ttkHUa8w.js";
import { n as e } from "./chunk-property-Baio2yOX.js";
import { o as x } from "./chunk-query-assigned-elements-DAuAKBi3.js";
import { W as z } from "./chunk-WithApiClient-Da1nY1F5.js";
import { h as $, i as _ } from "./chunk-task-VvT4GEb4.js";
import { r as C } from "./chunk-query-all-HFHP2HHm.js";
import { e as O } from "./chunk-base-CwU3eNq-.js";
import { o as S } from "./chunk-unsafe-html-BtxSMF-O.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function B(t) {
  return (a, o) => O(a, o, { async get() {
    var s;
    return await this.updateComplete, ((s = this.renderRoot) == null ? void 0 : s.querySelector(t)) ?? null;
  } });
}
var T = Object.defineProperty, P = Object.getOwnPropertyDescriptor, m = (t, a, o, s) => {
  for (var n = s > 1 ? void 0 : s ? P(a, o) : a, d = t.length - 1, p; d >= 0; d--)
    (p = t[d]) && (n = (s ? p(a, o, n) : p(n)) || n);
  return s && n && T(a, o, n), n;
};
let b = class extends g(y) {
  constructor() {
    super(...arguments), this.closeOthers = !1;
  }
  onClick(t) {
    this.modalId && (t.preventDefault(), this.modalIsOpen ? this.closeModal() : (this.closeOthers && this.closeAllModals(), this.openModal()));
  }
  updated(t) {
    var a;
    super.updated(t), this.toggleAttribute("open", this.modalIsOpen), (a = this.assignedElements) == null || a.forEach((o) => {
      o.toggleAttribute("open", this.modalIsOpen);
      const s = [
        "application",
        "button",
        "checkbox",
        "combobox",
        "gridcell",
        "link",
        "listbox",
        "menuitem",
        "row",
        "rowheader",
        "tab",
        "treeitem"
      ], n = o.getAttribute("role");
      s.includes(n) && o.setAttribute("aria-expanded", String(this.modalIsOpen));
    });
  }
  render() {
    return l`<slot @click="${this.onClick}"></slot>`;
  }
};
m([
  x()
], b.prototype, "assignedElements", 2);
m([
  e({ type: Boolean, attribute: "close-others" })
], b.prototype, "closeOthers", 2);
b = m([
  v("dialog-toggle")
], b);
const D = `/*! tailwindcss v4.1.5 | MIT License | https://tailwindcss.com */
@layer properties{@supports (((-webkit-hyphens:none)) and (not (margin-trim:inline))) or ((-moz-orient:inline) and (not (color:rgb(from red r g b)))){*,:before,:after{--tw-duration:initial;--tw-backdrop-blur:initial;--tw-backdrop-brightness:initial;--tw-backdrop-contrast:initial;--tw-backdrop-grayscale:initial;--tw-backdrop-hue-rotate:initial;--tw-backdrop-invert:initial;--tw-backdrop-opacity:initial;--tw-backdrop-saturate:initial;--tw-backdrop-sepia:initial;--tw-translate-x:0;--tw-translate-y:0;--tw-translate-z:0;--tw-ease:initial}::backdrop{--tw-duration:initial;--tw-backdrop-blur:initial;--tw-backdrop-brightness:initial;--tw-backdrop-contrast:initial;--tw-backdrop-grayscale:initial;--tw-backdrop-hue-rotate:initial;--tw-backdrop-invert:initial;--tw-backdrop-opacity:initial;--tw-backdrop-saturate:initial;--tw-backdrop-sepia:initial;--tw-translate-x:0;--tw-translate-y:0;--tw-translate-z:0;--tw-ease:initial}}}.dialog::backdrop{transform:translateZ(0)var(--tw-rotate-x,)var(--tw-rotate-y,)var(--tw-rotate-z,)var(--tw-skew-x,)var(--tw-skew-y,);opacity:0;transition-property:display,opacity,overlay;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function,cubic-bezier(.4,0,.2,1)));transition-duration:var(--tw-duration,var(--default-transition-duration,.15s));transition-behavior:allow-discrete;--tw-duration:.3s;background-color:#00000080;transition-duration:.3s;transition-delay:.1s;display:none}@supports (color:color-mix(in lab, red, red)){.dialog::backdrop{background-color:color-mix(in oklab,var(--color-black,#000)50%,transparent)}}@media (prefers-reduced-motion:reduce){.dialog::backdrop{transition-property:none}}.dialog[open]::backdrop{opacity:1;transition-delay:0s;display:block}.dialog.child-modal-true::backdrop{opacity:0}.dialog[blur-backdrop]::backdrop{--tw-backdrop-blur:blur(2px);-webkit-backdrop-filter:var(--tw-backdrop-blur,)var(--tw-backdrop-brightness,)var(--tw-backdrop-contrast,)var(--tw-backdrop-grayscale,)var(--tw-backdrop-hue-rotate,)var(--tw-backdrop-invert,)var(--tw-backdrop-opacity,)var(--tw-backdrop-saturate,)var(--tw-backdrop-sepia,);backdrop-filter:var(--tw-backdrop-blur,)var(--tw-backdrop-brightness,)var(--tw-backdrop-contrast,)var(--tw-backdrop-grayscale,)var(--tw-backdrop-hue-rotate,)var(--tw-backdrop-invert,)var(--tw-backdrop-opacity,)var(--tw-backdrop-saturate,)var(--tw-backdrop-sepia,)}@starting-style{.dialog[open]::backdrop{opacity:0}}.dialog{inset:calc(var(--spacing,.25rem)*0);margin:calc(var(--spacing,.25rem)*0);overscroll-behavior:contain;background-color:unset;opacity:1;width:100dvw;height:100dvh;transition-property:visibility,opacity,display;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function,cubic-bezier(.4,0,.2,1)));transition-duration:var(--tw-duration,var(--default-transition-duration,.15s));transition-behavior:allow-discrete;display:block;position:fixed;overflow:hidden}@media (prefers-reduced-motion:reduce){.dialog{transition-property:none}}.dialog:modal{max-height:100dvh}.dialog:modal{max-width:100vw}@media (min-width:48rem){.dialog[type=modal]{justify-content:center;align-items:center;display:flex}}.dialog:not([open]){pointer-events:none;visibility:hidden;opacity:0;--tw-duration:.7s;transition-duration:.7s;transition-delay:.5s}.dialog:not([open])::backdrop{opacity:0}@starting-style{.dialog[open]{opacity:0}}.dialog [lock-scroll=true]{overflow:hidden}.modal{--tw-translate-y:100%;width:100%;height:100%;translate:var(--tw-translate-x)var(--tw-translate-y);overscroll-behavior:contain;background-color:var(--color-white,#fff);opacity:0;transition-property:opacity,transform,overlay,translate;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function,cubic-bezier(.4,0,.2,1)));transition-duration:var(--tw-duration,var(--default-transition-duration,.15s));--tw-duration:.3s;--tw-ease:var(--ease-in-out,cubic-bezier(.4,0,.2,1));transition-duration:.3s;transition-delay:0s;transition-timing-function:var(--ease-in-out,cubic-bezier(.4,0,.2,1));overflow-y:auto}@media (prefers-reduced-motion:reduce){.modal{transition-property:none}}@media (min-width:48rem){.modal{--tw-translate-y:calc(var(--spacing,.25rem)*16);width:83.3333%;height:auto;translate:var(--tw-translate-x)var(--tw-translate-y)}}@media (min-width:64rem){.modal{max-height:100dvh;max-width:var(--container-2xl,42rem)}}.modal[size=modal-max]{width:100%!important;max-width:100%!important;height:100%!important;max-height:100%!important}.modal[size=modal-wide]{bottom:calc(var(--spacing,.25rem)*0);height:auto;position:absolute}@media (min-width:48rem){.modal[size=modal-wide]{bottom:auto}}@media (min-width:64rem){.modal[size=modal-wide]{max-width:var(--container-4xl,56rem)}}.modal[size=modal-wide] .dialog{align-items:center;display:flex}.dialog[open] .modal{--tw-translate-y:calc(var(--spacing,.25rem)*0);translate:var(--tw-translate-x)var(--tw-translate-y);opacity:1;transition-delay:75ms}.drawer:not([anchor=bottom]){right:calc(var(--spacing,.25rem)*0);--tw-translate-x:100%;width:100%;max-width:375px;height:100%;translate:var(--tw-translate-x)var(--tw-translate-y);overscroll-behavior:contain;background-color:var(--color-white,#fff);transition-property:transform,translate,scale,rotate;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function,cubic-bezier(.4,0,.2,1)));transition-duration:var(--tw-duration,var(--default-transition-duration,.15s));--tw-duration:.3s;--tw-ease:var(--ease-in-out,cubic-bezier(.4,0,.2,1));transition-duration:.3s;transition-delay:0s;transition-timing-function:var(--ease-in-out,cubic-bezier(.4,0,.2,1));--scrollbar-track:transparent;position:fixed;overflow-y:auto}.drawer:not([anchor=bottom])::-webkit-scrollbar-track{background-color:var(--scrollbar-track);border-radius:var(--scrollbar-track-radius)}.drawer:not([anchor=bottom])::-webkit-scrollbar-thumb{background-color:var(--scrollbar-thumb);border-radius:var(--scrollbar-thumb-radius)}.drawer:not([anchor=bottom])::-webkit-scrollbar-corner{background-color:var(--scrollbar-corner);border-radius:var(--scrollbar-corner-radius)}@supports ((-moz-appearance:none)){.drawer:not([anchor=bottom]){scrollbar-width:thin;scrollbar-color:var(--scrollbar-thumb,initial)var(--scrollbar-track,initial)}}.drawer:not([anchor=bottom])::-webkit-scrollbar{width:8px;height:8px;display:block}@media (prefers-reduced-motion:reduce){.drawer:not([anchor=bottom]){transition-property:none}}@media (min-width:64rem){.drawer:not([anchor=bottom]){max-width:450px}}.drawer[anchor=bottom]{bottom:calc(var(--spacing,.25rem)*0);overscroll-behavior:contain;width:100%;transition-property:transform,translate,scale,rotate;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function,cubic-bezier(.4,0,.2,1)));transition-duration:var(--tw-duration,var(--default-transition-duration,.15s));--tw-duration:.3s;--tw-ease:var(--ease-in-out,cubic-bezier(.4,0,.2,1));transition-duration:.3s;transition-delay:0s;transition-timing-function:var(--ease-in-out,cubic-bezier(.4,0,.2,1));--scrollbar-track:transparent;position:fixed;overflow-y:auto}.drawer[anchor=bottom]::-webkit-scrollbar-track{background-color:var(--scrollbar-track);border-radius:var(--scrollbar-track-radius)}.drawer[anchor=bottom]::-webkit-scrollbar-thumb{background-color:var(--scrollbar-thumb);border-radius:var(--scrollbar-thumb-radius)}.drawer[anchor=bottom]::-webkit-scrollbar-corner{background-color:var(--scrollbar-corner);border-radius:var(--scrollbar-corner-radius)}@supports ((-moz-appearance:none)){.drawer[anchor=bottom]{scrollbar-width:thin;scrollbar-color:var(--scrollbar-thumb,initial)var(--scrollbar-track,initial)}}.drawer[anchor=bottom]::-webkit-scrollbar{width:8px;height:8px;display:block}@media (prefers-reduced-motion:reduce){.drawer[anchor=bottom]{transition-property:none}}.drawer[anchor=left]{right:auto;left:calc(var(--spacing,.25rem)*0);transition-delay:0s}.drawer[anchor=bottom]{top:auto;bottom:calc(var(--spacing,.25rem)*0);--tw-translate-y:100%;translate:var(--tw-translate-x)var(--tw-translate-y)}.dialog[open] .drawer[anchor=bottom]{--tw-translate-y:calc(var(--spacing,.25rem)*0);translate:var(--tw-translate-x)var(--tw-translate-y)}.drawer[anchor=right]{transition-property:transform,translate,scale,rotate;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function,cubic-bezier(.4,0,.2,1)));transition-duration:var(--tw-duration,var(--default-transition-duration,.15s));--tw-duration:.15s;--tw-ease:var(--ease-out,cubic-bezier(0,0,.2,1));transition-duration:.15s;transition-timing-function:var(--ease-out,cubic-bezier(0,0,.2,1))}.dialog:not([open]) .drawer[anchor=right]{--tw-translate-x:100%;translate:var(--tw-translate-x)var(--tw-translate-y);transition-delay:0s}.dialog[open] .drawer[anchor=right]{--tw-translate-x:calc(var(--spacing,.25rem)*0);translate:var(--tw-translate-x)var(--tw-translate-y);transition-delay:75ms}.dialog:not([open]) .drawer[anchor=left]{--tw-translate-x:-100%;translate:var(--tw-translate-x)var(--tw-translate-y)}.dialog[open] .drawer[anchor=left]{--tw-translate-x:calc(var(--spacing,.25rem)*0);translate:var(--tw-translate-x)var(--tw-translate-y)}.dialog[open] .drawer{transition-delay:.1s;transform:none}.dialog[animate-in-place] .drawer{transition-delay:0s;transform:none}.dialog[animate-in-place]::backdrop{opacity:1;transition-property:none;transition-delay:0s}.dialog[animate-in-place]:not([open]){opacity:1;--tw-duration:75ms;transition-duration:75ms;transition-delay:0s}.dialog[animate-in-place]:not([open])::backdrop{opacity:1}@starting-style{.dialog[animate-in-place][open]::backdrop{opacity:1}}dialog[animate-on-open] :not(div):not(slot):not([data-close-button]):not(svg-icon){--tw-translate-x:calc(var(--spacing,.25rem)*-5);translate:var(--tw-translate-x)var(--tw-translate-y);opacity:0;transition-property:opacity,transform;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function,cubic-bezier(.4,0,.2,1)));transition-duration:var(--tw-duration,var(--default-transition-duration,.15s))}dialog[animate-on-open][open] :not(div):not(slot):not([data-close-button]):not(svg-icon){--tw-translate-x:calc(var(--spacing,.25rem)*0);translate:var(--tw-translate-x)var(--tw-translate-y);opacity:1;--tw-duration:.3s;--tw-ease:var(--ease-out,cubic-bezier(0,0,.2,1));transition-duration:.3s;transition-delay:.5s;transition-timing-function:var(--ease-out,cubic-bezier(0,0,.2,1))}@property --tw-duration{syntax:"*";inherits:false}@property --tw-backdrop-blur{syntax:"*";inherits:false}@property --tw-backdrop-brightness{syntax:"*";inherits:false}@property --tw-backdrop-contrast{syntax:"*";inherits:false}@property --tw-backdrop-grayscale{syntax:"*";inherits:false}@property --tw-backdrop-hue-rotate{syntax:"*";inherits:false}@property --tw-backdrop-invert{syntax:"*";inherits:false}@property --tw-backdrop-opacity{syntax:"*";inherits:false}@property --tw-backdrop-saturate{syntax:"*";inherits:false}@property --tw-backdrop-sepia{syntax:"*";inherits:false}@property --tw-translate-x{syntax:"*";inherits:false;initial-value:0}@property --tw-translate-y{syntax:"*";inherits:false;initial-value:0}@property --tw-translate-z{syntax:"*";inherits:false;initial-value:0}@property --tw-ease{syntax:"*";inherits:false}`;
var I = Object.defineProperty, L = Object.getOwnPropertyDescriptor, f = (t) => {
  throw TypeError(t);
}, i = (t, a, o, s) => {
  for (var n = s > 1 ? void 0 : s ? L(a, o) : a, d = t.length - 1, p; d >= 0; d--)
    (p = t[d]) && (n = (s ? p(a, o, n) : p(n)) || n);
  return s && n && I(a, o, n), n;
}, M = (t, a, o) => a.has(t) || f("Cannot " + o), E = (t, a, o) => a.has(t) ? f("Cannot add the same private member more than once") : a instanceof WeakSet ? a.add(t) : a.set(t, o), u = (t, a, o) => (M(t, a, "access private method"), o), c, h;
let r = class extends z(
  g(y)
) {
  constructor() {
    super(...arguments), E(this, c), this.type = "modal", this.anchor = "right", this.withoutTitle = !1, this.withoutClose = !1, this.child = !1, this.closeOnBackdropClick = !1, this.animateOnOpen = !1, this.lockDialogScroll = !1, this.blurBackground = !1, this.tangiblee = !1, this.animateInPlace = !1, this.headerClasses = "", this.headerPosition = "sticky", this.customGrid = "grid grid-cols-1 grid-rows-[var(--dmn-dialog-header-height,60px)_minmax(0,1fr)_auto]", this.closeIconSize = "9.5", this._loadURLContentTask = new $(this, {
      task: async ([t], { signal: a }) => {
        if (!this.hasToLoadURL)
          return _;
        const o = await this.$api.client.fetchClient(t, {
          method: "GET",
          signal: a,
          headers: {
            "Content-Type": "text/html"
          }
        });
        return a.throwIfAborted(), o;
      },
      args: () => [this.url]
    });
  }
  _handleBackdropClick(t) {
    this.closeOnBackdropClick && t.target instanceof HTMLElement && t.target.tagName === "DIALOG" && u(this, c, h).call(this);
  }
  _handleGenericClick(t) {
    const a = t.target;
    a.hasAttribute("close-modal") && (t.preventDefault(), u(this, c, h).call(this)), a.closest("[close-modal]") && (t.preventDefault(), u(this, c, h).call(this));
  }
  _focusOnFirstElement() {
    try {
      setTimeout(async () => {
        const t = await this.dialog;
        if (t) {
          const a = t.querySelector(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
          );
          a && a.focus();
        }
      }, 300);
    } catch (t) {
      console.error("Error in _focusOnFirstElement", t);
    }
  }
  firstUpdated(t) {
    super.firstUpdated(t), this.modalIsOpen && !this.open && this.show();
  }
  async show() {
    const t = await this.dialog;
    if (t && !t.open) {
      t.showModal(), this._focusOnFirstElement(), this.open = !0;
      const a = this.querySelector("template");
      a && a.id.includes("template-deferred__") && (this.appendChild(a.content.cloneNode(!0)), a.remove());
    }
  }
  async hide() {
    const t = await this.dialog;
    t && t.open && (t.close(), this.open = !1);
  }
  get hasToLoadURL() {
    const t = this.url;
    return !(!t || t === "#" || t === "about:blank" || t === "javascript:;" || t === "javascript:void(0)" || t === "");
  }
  get dialogContentHTML() {
    return this.hasToLoadURL ? l`
      ${this._loadURLContentTask.render({
      pending: () => l`<p class="caption animate-pulse p-5 text-center">Loading...</p>`,
      complete: (t) => t ? l`${S(t)}` : w
    })}
    ` : l`<slot @click=${this._handleGenericClick}></slot>`;
  }
  willUpdate(t) {
    t.has("url") && this.url !== "" && (this.urlParams = new URL(this.url).searchParams);
  }
  _renderDialog() {
    let t = "";
    return this.anchor === "left" ? t = "pl-safe-or-0" : this.anchor === "right" && (t = "pr-safe-or-0"), l`
      <dialog
        role="dialog"
        aria-modal="true"
        type="${this.type}"
        aria-labelledby="${this.id}-dialogTitle"
        @modal-close=${u(this, c, h)}
        @close=${u(this, c, h)}
        .inert=${!this.modalIsOpen}
        class="dialog child-modal-${this.child} z-20"
        @click=${this._handleBackdropClick}
        ?blur-backdrop=${this.blurBackground}
        ?animate-on-open=${this.animateOnOpen}
        ?animate-in-place=${this.animateInPlace}
      >
        <div
          class="${this.type || "modal"} ${t} ${this.customGrid}"
          size=${this.size}
          anchor=${this.anchor}
          lock-scroll=${this.lockDialogScroll}
          data-overlay
        >
          <div
            class="${this.headerPosition} ${this.headerClasses} ${this.withoutTitle && this.withoutClose ? "" : "px-4 py-2.5"} top-0 z-50 flex items-center justify-between"
          >
            <div
              class="${this.withoutTitle ? "sr-only" : ""} grow"
              id="${this.id}-dialogTitle"
            >
              <slot name="header"></slot>
            </div>

            ${this.withoutClose ? w : l`<button
                  @click=${u(this, c, h)}
                  class="btn btn--close ${this.tangiblee ? "scale-120 translate-y-1" : ""} ml-auto delay-0!"
                >
                  <slot name="close-icon">
                    <svg-icon
                      src="icon-close"
                      style="width: ${this.closeIconSize}px; height: ${this.closeIconSize}px"
                    ></svg-icon>
                    <span class="sr-only">Close</span>
                  </slot>
                </button>`}
          </div>
          <div>${this.dialogContentHTML}</div>
        </div>
      </dialog>
    `;
  }
  render() {
    return l`${this._renderDialog()}`;
  }
};
c = /* @__PURE__ */ new WeakSet();
h = function() {
  this.open && (this.child ? this.closeAllModals() : this.closeModal(), this.open = !1);
};
r.styles = [k(D)];
i([
  e({ type: Boolean, reflect: !0 })
], r.prototype, "open", 2);
i([
  e({ type: String, attribute: "defer-section" })
], r.prototype, "deferSection", 2);
i([
  e({ type: String, attribute: "defer-url" })
], r.prototype, "deferURL", 2);
i([
  e({ type: String })
], r.prototype, "type", 2);
i([
  e({ type: String, reflect: !0 })
], r.prototype, "size", 2);
i([
  e({ type: String })
], r.prototype, "anchor", 2);
i([
  e({ type: Boolean, reflect: !0, attribute: "without-title" })
], r.prototype, "withoutTitle", 2);
i([
  e({ type: Boolean, reflect: !0, attribute: "without-close" })
], r.prototype, "withoutClose", 2);
i([
  e({ type: Boolean, attribute: "child" })
], r.prototype, "child", 2);
i([
  e({ type: Boolean, attribute: "close-on-backdrop-click" })
], r.prototype, "closeOnBackdropClick", 2);
i([
  e({ type: Boolean, attribute: "animate-on-open" })
], r.prototype, "animateOnOpen", 2);
i([
  e({ type: Boolean, attribute: "lock-dialog-scroll" })
], r.prototype, "lockDialogScroll", 2);
i([
  e({ type: Boolean, attribute: "blur-background" })
], r.prototype, "blurBackground", 2);
i([
  e({ type: Boolean, attribute: "tangiblee" })
], r.prototype, "tangiblee", 2);
i([
  e({ type: Boolean, attribute: "animate-in-place" })
], r.prototype, "animateInPlace", 2);
i([
  e({ type: String, attribute: "header-classes" })
], r.prototype, "headerClasses", 2);
i([
  e({ type: String, attribute: "header-position" })
], r.prototype, "headerPosition", 2);
i([
  e({ type: String, attribute: "custom-grid" })
], r.prototype, "customGrid", 2);
i([
  e({ type: String, attribute: "close-icon-size" })
], r.prototype, "closeIconSize", 2);
i([
  e({ type: String, attribute: "url" })
], r.prototype, "url", 2);
i([
  e({ type: Object, reflect: !0, attribute: "url-params" })
], r.prototype, "urlParams", 2);
i([
  B("dialog")
], r.prototype, "dialog", 2);
i([
  C("iframe, video")
], r.prototype, "iframeOrVideo", 2);
r = i([
  v("modal-dialog")
], r);
export {
  r as ModalDialog
};
